import * as R from 'ramda';
import Vue from 'vue';
import Vuex from 'vuex';

import unitConfiguration from './store/unit-configuration';
import {M_SET_APP_STATE} from './store/mutation-types';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		unitConfiguration,
	},
	state: {
		app: {
			media: '',
			sidebars: {
				left: false,
				right: false,
			},
			isPartnerFormVisible: false, // shades the content when partner-area form is open
			isContractFormOverlayVisible: false, // shades the content when contract form overlay is open
			isConfigurationFormOverlayVisible: false, // similar to the above
			unitConfigurationId: null,
			isConfiguratorDirty: false,
			remark: '',
		},
		user: null,
	},
	mutations: {
		[M_SET_APP_STATE](state, new_state) {
			state.app = R.mergeDeepRight(state.app, new_state);
		},
		setUser(state, payload) {
			state.user = payload;
		},
		setConfiguratorDirty(state, payload) {
			state.isConfiguratorDirty = payload;
		},
		setRemark(state, payload) {
			state.app.remark = payload;
		},
	},
});
